import React from 'react';
import { Route, Switch } from 'react-router';
import CreateSchool from './create';
import EditSchool from './edit';

const Schools = () => {
  return (
    <Switch>
      <Route
        exact
        path='/admin/districts/:districtId/schools/new/'
        component={CreateSchool}
      />
      <Route
        exact
        path='/admin/districts/:districtId/schools/:id'
        component={EditSchool}
      />
    </Switch>
  );
};

export default Schools;
